<!-- 项目文件 -->
<template>
    <div class="w100p bgfff">
        <Header></Header>
        <Titleimg :img="bgImg"></Titleimg>
        <div class="pt24 pl16 pr16 pb30 bgf6">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    驾校招生小程序
                </span>
            </p>
            <div>
                <van-grid :column-num="2" :border="false">
                    <van-grid-item  >
                        <div class=" pb24 h100p w100p pb24 pt24  bgfff boxshow3">
                            <div class="mauto textc">
                                <img class="w70 h70" src="../../../public/img/img57.png" alt="">
                            </div>
                            <div class="mauto textc w65p pt16 posre flexc lh18">
                                <p class="fs14 c333 border-bottom2">文案/美术/策划</p>
                                <p class="fs14 c333 border-bottom2">专项要求高</p>
                            </div>
                        </div>
                    </van-grid-item>

                    <van-grid-item  >
                        <div class=" pb24 h100p w100p pb24 pt24  bgfff boxshow3">
                            <div class="mauto textc">
                                <img class="w70 h70" src="../../../public/img/img58.png" alt="">
                            </div>
                            <div class="mauto textc w65p pt16 posre flexc lh18">
                                <p class="fs14 c333 border-bottom2">人员成本高</p>
                                <p class="fs14 c333 border-bottom2">需要专人维护</p>
                            </div>
                        </div>
                    </van-grid-item>

                    <van-grid-item  >
                        <div class=" pb24 h100p w100p pb24 pt24  bgfff boxshow3">
                            <div class="mauto textc">
                                <img class="w70 h70" src="../../../public/img/img59.png" alt="">
                            </div>
                            <div class="mauto textc w65p pt16 posre flexc lh18">
                                <p class="fs14 c333 border-bottom2">需要微功能</p>
                                <p class="fs14 c333 border-bottom2">技术门槛高</p>
                            </div>
                        </div>
                    </van-grid-item>

                    <van-grid-item  >
                        <div class=" pb24 h100p w100p pb24 pt24  bgfff boxshow3">
                            <div class="mauto textc">
                                <img class="w70 h70" src="../../../public/img/img60.png" alt="">
                            </div>
                            <div class="mauto textc w65p pt16 posre flexc lh18">
                                <p class="fs14 c333 border-bottom2">不懂驾培行业</p>
                                <p class="fs14 c333 border-bottom2">专业要求高</p>
                            </div>
                        </div>
                    </van-grid-item>

                </van-grid>
            </div>
        </div>

        <div class=" pl16 pr16 pt24 pb24">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    驾校招生小程序
                </span>
            </p>
            <div class="w100p  pt24 pb24">
                <ul class="overflow w100p row1_txtc">
                    <li class="w30p pt5 pb5 fs14 c333  textc bgED  disinblock bradius50" :class="{bgact:isAct == 1}"
                        @click="changeBg(1)">
                        驾校微官网
                    </li>
                    <li class="w30p pt5 pb5 fs14 c333  pl5 pr5 textc bgED  disinblock bradius50" :class="{bgact:isAct == 2}"
                        @click="changeBg(2)">
                        微信服务号菜单
                    </li>
                    <li class="w30p pt5 pb5 fs14 c333   textc bgED  disinblock bradius50" :class="{bgact:isAct == 3}"
                        @click="changeBg(3)">
                        微信推送矩阵
                    </li>
                </ul>

            </div>
            <div class="posre overflow"> 
                <transition name="fade" mode="out-in">
                    <ul class="floatl disblock w100p h100p " v-if="isAct==1">
                        <li class="mb16 bg61 fs14 pt10 pb10 textc">
                            可兼容iOS、android、WP等多种智能手机操作系统
                        </li>
                        <li class="mb16 bg62 fs14 pt10 pb10 textc">
                            可便捷的与微信、微博等网络互动咨询平台链接
                        </li>
                        <li class="mb16 bg63 fs14 pt10 pb10 textc">
                            可将驾校所需微功能融合，使用推广方便快捷
                        </li>
                        <li class="mb16 bg64 fs14 pt10 pb10 textc">
                            多款模版随意选择，展现方式丰富
                        </li>
                        <li class="mb16 bg65 fs14 pt10 pb10 textc">
                            多款模版随意选择，展现方式丰富
                        </li>
                        <li class="mb16 bg66 fs14 pt10 pb10 textc">
                            访问便捷，安全，用户体验更佳
                        </li>
                    </ul>
                </transition>
                <transition name="fade" mode="out-in">
                    <ul class="floatl disblock w100p h100p" v-if="isAct==2">
                        <li class="mb16 bg61 fs14 pt10 pb10 textc">
                            可兼容iOS、android、WP等多种智能手机操作系统
                        </li>
                        <li class="mb16 bg62 fs14 pt10 pb10 textc">
                            可便捷的与微信、微博等网络互动咨询平台链接
                        </li>
                        <li class="mb16 bg63 fs14 pt10 pb10 textc">
                            可将驾校所需微功能融合，使用推广方便快捷
                        </li>
                        <li class="mb16 bg64 fs14 pt10 pb10 textc">
                            多款模版随意选择，展现方式丰富
                        </li>
                        <li class="mb16 bg65 fs14 pt10 pb10 textc">
                            多款模版随意选择，展现方式丰富
                        </li>
                        <li class="mb16 bg66 fs14 pt10 pb10 textc">
                            访问便捷，安全，用户体验更佳
                        </li>
                    </ul>
                </transition>
                <transition name="fade" mode="out-in">
                    <ul class="floatl disblock w100p h100p" v-if="isAct==3">
                        <li class="mb16 bg61 fs14 pt10 pb10 textc">
                            可兼容iOS、android、WP等多种智能手机操作系统
                        </li>
                        <li class="mb16 bg62 fs14 pt10 pb10 textc">
                            可便捷的与微信、微博等网络互动咨询平台链接
                        </li>
                        <li class="mb16 bg63 fs14 pt10 pb10 textc">
                            可将驾校所需微功能融合，使用推广方便快捷
                        </li>
                        <li class="mb16 bg64 fs14 pt10 pb10 textc">
                            多款模版随意选择，展现方式丰富
                        </li>
                        <li class="mb16 bg65 fs14 pt10 pb10 textc">
                            多款模版随意选择，展现方式丰富
                        </li>
                        <li class="mb16 bg66 fs14 pt10 pb10 textc">
                            访问便捷，安全，用户体验更佳
                        </li>
                    </ul>
                </transition>

            </div>
        </div>


        <div class=" pt8 pb50">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    为什么选择我们
                </span>
            </p>
            <div class="w100p  mt24 posre minh160  bg67" ref="lightBtn">
                <div class=" posre overflow  ">
                    <div class="w42p floatl pl16">
                        <ul class="textl pt6">
                            <transition name="moveLL">
                                <li class="pt6 pb6" v-show="show1==1">
                                    <img class="imgauto" src="../../../public/img/img266.png" alt="">
                                </li>
                            </transition>
                            <transition name="moveLL">
                                <li class="pt6 pb6" v-show="show2==1">
                                    <img class="imgauto" src="../../../public/img/img267.png" alt="">
                                </li>
                            </transition>
                            <transition name="moveLL">
                                <li class="pt6 pb6" v-show="show3==1">
                                    <img class="imgauto" src="../../../public/img/img268.png" alt="">
                                </li>
                            </transition>
                            <transition name="moveLL">
                                <li class="pt6 pb6" v-show="show4==1">
                                    <img class="imgauto" src="../../../public/img/img269.png" alt="">
                                </li>
                            </transition>
                        </ul>
                    </div>
                    <div class="w45p floatr pr16">
                        <ul class="textr pt6">
                            <transition name="moveRR">
                                <li class="pt6 pb6" v-show="show5==1">
                                    <img class="imgauto" src="../../../public/img/img270.png" alt="">
                                </li>
                            </transition>
                            <transition name="moveRR">
                                <li class="pt6 pb6" v-show="show6==1">
                                    <img class="imgauto" src="../../../public/img/img271.png" alt="">
                                </li>
                            </transition>
                            <transition name="moveRR">
                                <li class="pt6 pb6" v-show="show7==1">
                                    <img class="imgauto" src="../../../public/img/img272.png" alt="">
                                </li>
                            </transition>
                            <transition name="moveRR">
                                <li class="pt6 pb6" v-show="show8==1">
                                    <img class="imgauto" src="../../../public/img/img273.png" alt="">
                                </li>
                            </transition>
                        </ul>
                    </div>
                </div>
            </div>
           
        </div>
        <Applyset></Applyset>
        <Footer></Footer>
        
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Titleimg from '@/components/Titleimg';
    import Applyset from '@/components/Applyset';
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../../public/img/img56.png'),
                isAct: 1,
                show1: 0,
                show2: 0,
                show3: 0,
                show4: 0,
                show5: 0,
                show6: 0,
                show7: 0,
                show8: 0,
            };
        },
        components: {
            Header,
            Titleimg,
            Footer,
            Applyset
        },
        methods: {
            changeBg(index) {
                this.isAct = index;
            },
            handleScroll() {
                const isElementNotInViewport = function(el) {
                    let rect = el.getBoundingClientRect();
                    return (
                        rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
                        rect.bottom <= 0
                    );
                };

                if (isElementNotInViewport(this.$refs.lightBtn)) {
                    this.show1 = 0;
                    this.show2 = 0;
                    this.show3 = 0;
                    this.show4 = 0;
                    this.show5 = 0;
                    this.show6 = 0;
                    this.show7 = 0;
                    this.show8 = 0;
                } else {
                    setTimeout(() => {
                        this.show1 = 1;
                        this.show5 = 1;
                    }, 100);
                    setTimeout(() => {
                        this.show2 = 1;
                        this.show6 = 1;
                    }, 200);
                    setTimeout(() => {
                        this.show3 = 1;
                        this.show7 = 1;
                    }, 300);
                    setTimeout(() => {
                        this.show4 = 1;
                        this.show8 = 1;
                    }, 400);
                }
            },

        },
        created() {

        },
        mounted() {
            this.$nextTick(() => {
                let timer;
                window.addEventListener("scroll", () => {
                    if (this.isFixed) {
                        this.isFixed = false;
                    }
                    if (timer) {
                        clearTimeout(timer);
                    }
                    timer = setTimeout(() => {
                        this.handleScroll();
                    }, 200);
                });
                this.handleScroll();
            });
        },
    }
</script>
<style scoped>
    /deep/.van-grid-item .van-grid-item__content {
        padding: 8px 8px;
        background-color: #F6F6F6;
    }
    
    .bgact {
        color: #3F8DF7;
        font-weight: 600;
        background-color: #EDF2FF;
    }
    
    .bg61 {
        background-image: url('../../../public/img/img61.png');
        background-size: 100%;
        background-repeat: no-repeat;
        color: #FF9211;
    }
    
    .bg62 {
        background-image: url('../../../public/img/img62.png');
        background-size: 100%;
        background-repeat: no-repeat;
        color: #14D79E;
    }
    
    .bg63 {
        background-image: url('../../../public/img/img63.png');
        background-size: 100%;
        background-repeat: no-repeat;
        color: #4850C7;
    }
    
    .bg64 {
        background-image: url('../../../public/img/img64.png');
        background-size: 100%;
        background-repeat: no-repeat;
        color: #FF5353;
    }
    
    .bg65 {
        background-image: url('../../../public/img/img65.png');
        background-size: 100%;
        background-repeat: no-repeat;
        color: #1F82F6;
    }
    
    .bg66 {
        background-image: url('../../../public/img/img66.png');
        background-size: 100%;
        background-repeat: no-repeat;
        color: #FFC600;
    }
    
    .bg67 {
        background-image: url('../../../public/img/img67.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    
    .moveLL-enter-active {
        transition: all 0.3s linear;
        transform: translateX(0%);
    }
    
    .moveLL-enter {
        transform: translateX(-100%);
    }
    
    .moveRR-enter-active {
        transition: all 0.3s linear;
        transform: translateX(0);
    }
    
    .moveRR-enter {
        transform: translateX(100%);
    }
</style>